import axios from "axios";

const BaseURL: string =
  process.env.REACT_APP_API_BASE_URL || "https://calculator.ecosail.app/v1/api/";

export const globalAPI = axios.create({
  baseURL: `${BaseURL}`,
  headers: {
    "Content-type": "application/json",
  },
  //withCredentials: true
});
